const FallBack = () => {
    return (
        <>
            There was an error
        </>
    )
}

export default FallBack;
